import ApplicationForm from '@/components/forms/ApplicationForm';

export default function Media() {
  return (
    <ApplicationForm
      applicationType="media"
      title="Media"
      description="Are you a photographer, videographer, journalist, or content creator? Apply for 
        media accreditation to capture and share the magic of Frequency Forest with the world."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={false}
      showCertificates={false}
    />
  );
}
